import React from 'react'

function Info() {
  return (
    <div className='info-container'>
        <div className='info-left'>
            <h1>Read everyday </h1>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Rerum molestiae explicabo commodi odio veniam placeat neque et modi repellat esse doloribus labore fugit iure molestias officiis dignissimos, mollitia impedit ex.
            Enim officiis assumenda explicabo error consequatur voluptatibus eaque dolorum, nobis optio, quam natus minus numquam facere debitis eos officia rerum ex atque. Similique quos consectetur fugit autem ex vel impedit.
            Aliquam aliquid quod veniam voluptate enim adipisci eligendi ipsam ducimus dolore commodi quia cumque impedit eum amet sequi, laudantium error in quae dolor aperiam, dignissimos corrupti facilis? Est, ipsa veniam?
        </p>
        </div>
        <div className='info-right'>
            
        </div>
    </div>
  )
}

export default Info